
export default {
  'how_it_works.title': 'Cómo funciona Pink Paradise',
  'how_it_works.subtitle': 'Descubre nuestra plataforma y cómo sacarle el máximo partido',
  'how_it_works.for_clients': 'Para Clientes',
  'how_it_works.for_escorts': 'Para Escorts',
  'how_it_works.secure_private': 'Seguro y Privado',
  'how_it_works.verified_profiles': 'Perfiles Verificados',
  'how_it_works.secure_payments': 'Pagos Seguros',
  
  // For clients section
  'how_it_works.browse_profiles': 'Explorar perfiles',
  'how_it_works.browse_profiles_desc': 'Explora perfiles de escorts con información detallada.',
  'how_it_works.subscribe': 'Suscribirse',
  'how_it_works.subscribe_desc': 'Elige un plan de suscripción que se adapte a tus necesidades.',
  'how_it_works.connect': 'Conectar',
  'how_it_works.connect_desc': 'Envía mensajes a escorts directamente a través de nuestra plataforma segura.',
  'how_it_works.arrange': 'Organizar encuentros',
  'how_it_works.arrange_desc': 'Programa encuentros discretos con total privacidad.',
  
  // For escorts section
  'how_it_works.create_profile': 'Crea tu perfil',
  'how_it_works.create_profile_desc': 'Muestra tu personalidad y servicios.',
  'how_it_works.get_verified': 'Verificarse',
  'how_it_works.get_verified_desc': 'Completa nuestro proceso de verificación para ganar la confianza de los clientes.',
  'how_it_works.offer_subscriptions': 'Ofrecer suscripciones',
  'how_it_works.offer_subscriptions_desc': 'Crea suscripciones para fans a 5€/mes para contenido exclusivo.',
  'how_it_works.manage_bookings': 'Gestionar reservas',
  'how_it_works.manage_bookings_desc': 'Control total sobre tu agenda y selección de clientes.',
  
  // Feature descriptions
  'how_it_works.secure_private_desc': 'El cifrado de extremo a extremo y las características avanzadas de privacidad protegen tu identidad.',
  'how_it_works.verified_profiles_desc': 'Cada escort es verificada para garantizar experiencias auténticas y seguras.',
  'how_it_works.secure_payments_desc': 'Facturación discreta y múltiples opciones de pago para tu comodidad.',
  
  // FAQ section
  'how_it_works.faq': 'Preguntas Frecuentes',
  'how_it_works.faq_privacy': '¿Cómo se protege mi privacidad?',
  'how_it_works.faq_privacy_answer': 'Tu privacidad es nuestra máxima prioridad. Todas las comunicaciones están cifradas y la información personal está protegida con medidas de seguridad líderes en la industria.',
  'how_it_works.faq_subscription': '¿Qué niveles de suscripción están disponibles?',
  'how_it_works.faq_subscription_answer': 'Ofrecemos navegación gratuita, y suscripciones Teaser, Regular y VIP. Cada nivel proporciona diferentes niveles de acceso a información y funciones de escorts.',
  'how_it_works.faq_verification': '¿Cómo funcionan las verificaciones de escorts?',
  'how_it_works.faq_verification_answer': 'Las escorts se someten a un proceso de verificación exhaustivo que incluye verificación de ID, verificación de fotos y comprobaciones de antecedentes para garantizar la autenticidad.',
  
  // Call to action
  'how_it_works.ready': '¿Listo para empezar?',
  'how_it_works.join_today': 'Únete a Pink Paradise hoy y descubre un nuevo mundo de encuentros auténticos.',
  'how_it_works.create_account': 'Crear una Cuenta',
  'how_it_works.explore_profiles': 'Explorar Perfiles',
};
